export default __webpack_public_path__ + "static/media/spinner.a6b7f400.gif";